module.exports = __webpack_public_path__ + "static/media/djeeta.d4f8b88d.png";